export default {"src":"/_next/static/media/LOGOUT.ee7ccad2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};